// eslint-disable-next-line no-restricted-imports
import { get, set } from 'local-storage'; // This is the only place where this import is allowed.

import { TAuthState } from 'src/redux/auth/auth.slice';
import { TMapState } from '../redux/map/map.slice';

export enum ELsKey {
  TOKEN_AUTH = 'TOKEN_AUTH',
  SIMULATIONS = 'SIMULATIONS',
  WILLI_COMMUNITY = 'WILLI_COMMUNITY',
}

// prettier-ignore
type TData<T> = 
  T extends ELsKey.TOKEN_AUTH ? TAuthState['tokenAuth'] :
  T extends ELsKey.SIMULATIONS ? TMapState['globalSimulationLocations'] :
  null;

export const ls = {
  set<T extends ELsKey>(key: T, value: TData<T>): void {
    set(key, value);
  },
  get<T extends ELsKey>(key: T): TData<T> | null {
    return get(key);
  },
};
